(function($) {

    const Stores = {
        Map: null,
        ContainerIdMapbox: "wtb-map-box",
        /* Los nodos se resuelven en init() y no aqui: el bundle se carga diferido, asi que con
           el objeto literal se buscaban antes de que existiera el DOM y quedaban en null. El
           unico que se comprobaba era el del mapa; el primer addEventListener sobre cualquier
           otro se llevaba por delante el resto del fichero */
        SelectContinent: null,
        InputSearchElement: null,
        SuggestionsElement: null,
        ContainerResultsElement: null,
        CustomPopupElement: null,
        FilterResultsElement: null,
        EmptyResultsElement: null,
        CountResultsElement: null,
        /* Copia local de lo que se pinta en cada fuente. Antes se leia `source._data`, que es
           API privada de Mapbox y puede desaparecer en cualquier version */
        Features: {
            distributors: [],
            santacole: []
        },
        SearchTimer: null,
        SearchRequestId: 0,
        /**
         * Lista de regiones geográficas predefinidas, cada una representada por un nombre y una caja delimitadora (bounding box).
         *
         * Cada región tiene el siguiente formato:
         *   - name: Nombre descriptivo de la región (por ejemplo, "Europa", "Norte América").
         *   - bbox: Array de 4 números [minLongitude, minLatitude, maxLongitude, maxLatitude], que define la caja delimitadora de la región.
         *     - minLongitude: Longitud mínima (oeste)
         *     - minLatitude: Latitud mínima (sur)
         *     - maxLongitude: Longitud máxima (este)
         *     - maxLatitude: Latitud máxima (norte)
         *
         * Estas regiones permiten centrar o limitar el mapa a áreas específicas del mundo, facilitando la navegación y búsqueda de tiendas por continente o zona amplia.
         *
         * **Nota**: Se utiliza este enfoque porque la API de Mapbox Geocoding no permite filtrar resultados por continente directamente.
         *
         * @type {Array<{name: string, bbox: [number, number, number, number]}>}
         */
        Regions: [
            // {
            //     name: 'Nombre', // este valor debe de coincidir con el value en el select
            //     bbox: [minLongitude, minLatitude, maxLongitude, maxLatitude] // Aproximado
            // },
            {
                name: 'europe',
                bbox: [-31.3, 34.5, 40.0, 72.0]
            },
            {
                name: 'north america',
                bbox: [-168.1, 15.0, -52.2, 83.16]
            },
            {
                name: 'south america',
                bbox: [-92.0, -56.0, -30.0, 32.0]
            },
            {
                name: 'asia',
                bbox: [60.0, -10.0, 180.0, 61.0]
            },
            {
                name: 'oceania',
                bbox: [110.0, -50.0, 180.0, 5.0]
            }
        ],

        GeoJsonSanta: [
            {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [-73.99002116137417, 40.73934939235165]
                },
                properties: {
                    id: 'brodway',
                    tipo: 'Galería',
                    name: 'Galería Santa & Cole Nueva York',
                    address: '907 Broadway, 4th Floor New York, NY 10010',
                    city: 'New York (Manhattan)',
                    country: 'Estados Unidos (USA)',
                    postal: '10003'
                }
            },
            {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [2.3383941341663426, 41.628362027113845],
                },
                properties: {
                    id: 'belloch',
                    tipo: 'Galería',
                    name: 'Galería Santa & Cole Belloch',
                    address: 'Ctra. C-251 Km. 5,6 Parc de Belloch, 08430, Barcelona',
                    city: 'Barcelona',
                    country: 'España',
                    postal: '08430'
                }
            },
            {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [-99.19064833262136, 19.42877310843326],
                },
                properties: {
                    id: 'mexico',
                    tipo: 'Galería',
                    name: 'Galería Santa & Cole Ciudad de México',
                    address: 'Campos Elíseos 158, Polanco, Polanco V Secc, Miguel Hidalgo, 11560 Ciudad de México, CDMX',
                    city: 'Ciudad de México',
                    country: 'Estados Unidos (USA)',
                    postal: '11560'
                }
            }
        ],

        init: function(){

            if(document.getElementById(this.ContainerIdMapbox) == null){
                console.warn(`No se ha encontrado el contenedor para mapbox "#${this.ContainerIdMapbox}"`);
                return;
            }

            this.SelectContinent         = document.getElementById('mapbox-continent');
            this.InputSearchElement      = document.getElementById('mapbox-search');
            this.SuggestionsElement      = document.getElementById('mapbox-suggestions');
            this.ContainerResultsElement = document.getElementById('wtb-mapbox-results');
            this.CustomPopupElement      = document.getElementById('wtb-popup');
            this.FilterResultsElement    = document.getElementById('wtb-results-filter');
            this.EmptyResultsElement     = document.getElementById('wtb-results-empty');
            this.CountResultsElement     = document.getElementById('mapbox-results-count');

            /* El token sale de PHP (constante MAPBOX_TOKEN) y si no esta definida se cae al de
               siempre, que hasta ahora estaba escrito a fuego aqui y viajaba dentro del bundle:
               asi se puede cambiar por entorno sin recompilar */
            mapboxgl.accessToken = store_locator_data?.mapboxToken || "pk.eyJ1IjoiYWRtaW53ZWJ1cmJpZGF0YSIsImEiOiJjbWQ3OWRtangwZXU0MmtyMDVzcms4M2tmIn0.TO0y2-yxnF37PxeiOOAFVA";

            this.listenEvents();

            /* En movil el contenedor del mapa va oculto por CSS (`hidden md:block` en wtb.php).
               Crear el mapa ahi no pinta nada, pero descarga tiles y cuenta como "map load" en la
               facturacion de Mapbox, asi que se deja para cuando el contenedor sea visible. La
               lista de tiendas si se carga, que es lo que se ve en movil. */
            if(!this.isMapContainerVisible()){
                this.loadDistributors(this.getContinent());
                this.watchForMapContainer();

                return;
            }

            this.createMap();
        },

        /**
         * Si el contenedor del mapa esta visible (no lo ha escondido el CSS).
         */
        isMapContainerVisible: function(){
            const container = document.getElementById(this.ContainerIdMapbox);

            return container != null && container.offsetParent !== null;
        },

        /**
         * Crea el mapa cuando el contenedor aparece al redimensionar, para no dejar la pagina sin
         * mapa hasta la siguiente recarga si se cruza el breakpoint.
         */
        watchForMapContainer: function(){
            let timer = null;

            window.addEventListener('resize', () => {
                if(this.Map) return;

                clearTimeout(timer);
                timer = setTimeout(() => {
                    if(!this.Map && this.isMapContainerVisible()){
                        this.createMap();
                    }
                }, 250);
            });
        },

        /**
         * Listeners que no dependen del mapa: el select de continente, el buscador y la lista de
         * resultados. Se enganchan siempre, tambien en movil, donde no hay mapa pero si hay lista.
         */
        listenEvents: function(){
            // --- LISTENERS FOR EVENTS ----------------------------------------
            // Event select de continente, se usa jquery para el evento de select2
            // debido a que jsvanilla no consigue escuchar el evento correctamente
            // El 'change' es la red por si select2 no llegara a inicializarse
            jQuery(this.SelectContinent).on('select2:select change', (event) => {
                const continent = this.getContinent();

                /* La lista se recarga siempre. Antes se salia antes de tiempo cuando el
                   continente no estaba en Regions y quedaban en pantalla los resultados del
                   continente anterior */
                this.loadDistributors(continent);

                const region = this.Regions.find( continentData => continentData.name === continent);

                if(!region){
                    console.warn(`No hay bbox para el continente "${continent}"`);
                    return;
                }

                const [minLng, minLat, maxLng, maxLat] = region.bbox;
                const centerLng = (minLng + maxLng) / 2;
                const centerLat = (minLat + maxLat) / 2;

                this.goToLocation(centerLng, centerLat, 3);
            });

            /* Buscador de la propia lista: filtra las tarjetas ya cargadas, sin ir al servidor.
               No toca los marcadores del mapa a proposito; para acotar el mapa esta el buscador
               de arriba, que es el que geolocaliza */
            this.FilterResultsElement?.addEventListener('input', () => this.filterResults());

            // Event input en el buscador del mapa
            if(this.InputSearchElement){
                /* 'input' con espera en vez de 'keyup' a pelo: cada tecla era una peticion al
                   geocoding de Mapbox */
                this.InputSearchElement.addEventListener('input', () => {
                    clearTimeout(this.SearchTimer);
                    this.SearchTimer = setTimeout(() => this.searchInMap(), 350);
                });
            }

            // Event lista resutados y distribuidores segurn el buscador del mapa
            this.SuggestionsElement?.addEventListener('click', (event) => {
                if (event.target.tagName !== 'LI')  return;
                const lng = parseFloat(event.target.dataset.lng);
                const lat = parseFloat(event.target.dataset.lat);
                const city = event.target.dataset.city || '';
                const region = event.target.dataset.region || '';
                const country = event.target.dataset.country || '';
                const countryCode = event.target.dataset.countryCode || '';
                const regionCode = event.target.dataset.regionCode || '';

                let zoomLevel = 5; // Zoom por defecto solo country

                if(city){
                   zoomLevel = 12;
                }else if(region && country){
                   zoomLevel = 7;
                }
                this.goToLocation(lng, lat, zoomLevel);
                this.loadDistributors(this.getContinent(), countryCode, regionCode, city);

                // Ocultar sugerencias al seleccionar una
                this.SuggestionsElement.parentElement.classList.add('hidden');
            });

            // Event nos desplazamos asta el marker al selecionar un distribuidor
            this.ContainerResultsElement?.addEventListener('click', (event) => {
                const elementClick = event.target.closest('.wtb-store');
                if(elementClick == null) return;

                /* Las guardas de antes encadenaban con && tres condiciones que solo se cumplen
                   a la vez con `undefined`, asi que un NaN pasaba de largo */
                const lng = parseFloat(elementClick.dataset.lng);
                const lat = parseFloat(elementClick.dataset.lat);

                if(!Number.isFinite(lng) || !Number.isFinite(lat)){
                    return;
                }

                const distributorId = elementClick.getAttribute("id");

                this.handleClickPoint(distributorId);
            });
        },

        createMap: function(){

            // Inicializar el mapa
            this.Map = new mapboxgl.Map({
                container: this.ContainerIdMapbox,
                //style: 'mapbox://styles/mapbox/streets-v11',
                style: store_locator_data.siteUrl + '/wp-content/themes/santacole/assets/public/mapbox-style/style.json', // Ruta al estilo personalizado
                projection: 'mercator', // Display the map as a globe, since satellite-v9 defaults to Mercator
                zoom: 5,
                center: [2.3, 41.9] // Coordenadas [lng, lat]
            });
            this.Map.addControl(new mapboxgl.NavigationControl());
            this.Map.scrollZoom.disable();

            /* Los marcadores iniciales se cargan dentro de `style.load`, cuando ya existe la
               fuente 'distributors': aqui la peticion podia resolverse antes que el estilo y el
               setData reventaba contra un getSource() sin definir */

            this.Map.on('style.load', () => {
                // Mapbox solo permite cargat imagenes png y JPEG
                this.Map.loadImage('/wp-content/themes/santacole/assets/public/mapbox-style/logo-sc-pin.png', (error, image) => {
                    if (error) throw error;
                    if (!this.Map.hasImage('logo-sc-pin')) {
                        this.Map.addImage('logo-sc-pin', image);
                    }
                });
                this.Map.loadImage('/wp-content/themes/santacole/assets/public/mapbox-style/cluster-pin.png', (error, image) => {
                    if (error) throw error;
                    if (!this.Map.hasImage('distributors-pin')) {
                        this.Map.addImage('distributors-pin', image);
                    }
                });
                this.Map.loadImage('/wp-content/themes/santacole/assets/public/mapbox-style/pin-active.png', (error, image) => {
                    if (error) throw error;
                    if (!this.Map.hasImage('pin-active')) {
                        this.Map.addImage('pin-active', image);
                    }
                });
                // --- Source layers distribuidores ----------------------------
                this.Map.addSource('distributors', {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: []
                    },
                    cluster: true,
                    clusterMaxZoom: 11,
                    clusterRadius: 50
                });

                // Layer para el circulo de agrupados
                this.Map.addLayer({
                    id: 'distributors-grup',
                    type: 'circle',
                    source: 'distributors',
                    filter: ['has', 'point_count'],
                    paint: {
                        'circle-opacity': 0.7,
                        'circle-stroke-width': 1.5,
                        'circle-stroke-color': '#F1F5F9',
                        'circle-color': '#1C1917',
                        'circle-radius': ['step', ['get', 'point_count'], 20, 10, 25, 25, 30]
                    }
                });

                // Layer para el numero de agrupados
                this.Map.addLayer({
                    id: 'distributors-count',
                    type: 'symbol',
                    source: 'distributors',
                    filter: ['has', 'point_count'],
                    layout: {
                        'text-size': 16,
                        'text-font': ["Open Sans Bold"],
                        'text-field': '{point_count_abbreviated}',
                    },
                    paint: {
                        'text-color': '#FAFAF9'
                    }

                });
                // Layer para un marker solo
                this.Map.addLayer({
                    id: 'distributors-point',
                    type: 'symbol',
                    source: 'distributors',
                    filter: ['!', ['has', 'point_count']],
                    layout: {
                        'icon-image': [
                            'case',
                            ['==', ['get', 'selected'], true],
                            'pin-active',
                            'distributors-pin'
                        ],
                        'icon-size': 0.4,
                        'icon-anchor': 'bottom', // para alinear la punta al punto
                        'icon-allow-overlap': true
                    }
                });


                // --- Source layers Santacole ---------------------------------
                this.Map.addSource('santacole', {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: this.GeoJsonSanta
                    },
                    cluster: true,
                    clusterMaxZoom: 11,
                    clusterRadius: 50
                });
                // Layer para el circulo de agrupados
                this.Map.addLayer({
                    id: 'santacole-group',
                    type: 'circle',
                    source: 'santacole',
                    filter: ['has', 'point_count'],
                    paint: {
                        'circle-opacity': 0.7,
                        'circle-stroke-width': 1.5,
                        'circle-stroke-color': '#F1F5F9',
                        'circle-color': '#1C1917',
                        'circle-radius': ['step', ['get', 'point_count'], 20, 10, 25, 25, 30]
                    }
                });

                // Layer para el numero de agrupados
                this.Map.addLayer({
                    id: 'santacole-count',
                    type: 'symbol',
                    source: 'santacole',
                    filter: ['has', 'point_count'],
                    layout: {
                        'text-size': 16,
                        'text-font': ["Open Sans Bold"],
                        'text-field': '{point_count_abbreviated}',
                    },
                    paint: {
                        'text-color': '#FAFAF9'
                    }

                });
                // Layer para un marker solo
                this.Map.addLayer({
                    id: 'santacole-point',
                    type: 'symbol',
                    source: 'santacole',
                    filter: ['!', ['has', 'point_count']],
                    layout: {
                        'icon-image': 'logo-sc-pin',
                        'icon-size': 0.2,
                        'icon-anchor': 'bottom', // para alinear la punta al punto
                        'icon-allow-overlap': true
                    }
                });


                ['distributors-point', 'santacole-point'].forEach( idLayer => {
                    // Event pop-up al hacer click en un marker
                    this.Map.on('click', idLayer, (e) => {
                        const clickedId = e.features[0].properties.id;
                        const sourceLayer = e.features[0].layer.source;
                        this.handleClickPoint(clickedId, sourceLayer);
                    });
                });

                ['distributors-grup', 'santacole-group'].forEach( idLayer => {
                    this.Map.on('click', idLayer, (event) => {
                        const source = event.features[0].layer.source;
                        const clusterId = event.features[0].properties.cluster_id;
                        this.Map.getSource(source).getClusterExpansionZoom(clusterId, (error, zoom) => {
                            if (error) return;
                            const coordinates = event.lngLat;
                            this.goToLocation(coordinates.lng, coordinates.lat, zoom);
                        });
                    });
                });


                ['distributors-grup', 'santacole-group', 'distributors-point', 'santacole-point'].forEach( idLayer => {
                    this.Map.on('mouseleave', idLayer, () => this.Map.getCanvas().style.cursor = '');
                    this.Map.on('mouseenter', idLayer, () => this.Map.getCanvas().style.cursor = 'pointer');
                });

                // Las galerias no cambian, se guardan tal cual para poder buscar en ellas
                this.Features.santacole = this.GeoJsonSanta;

                // Marcadores iniciales, ya con las fuentes creadas
                this.loadDistributors(this.getContinent());
            });
        },

        handleClickPoint: function(featureId, sourceLayer = "distributors") {
            const feature = featureId ? this.getFeatureGeoJson(featureId, sourceLayer) : null;

            /* Sin featureId, o con uno que ya no esta en la fuente (por ejemplo tras cambiar de
               continente), se cierra el popup. Antes se leia `feature.properties` sin comprobar
               que hubiera feature */
            if(!feature){
                this.CustomPopupElement?.classList.add("hidden");
                return;
            }

            const properties = feature.properties;
            /* Con el ?. porque en movil se puede pulsar una tarjeta de la lista sin que exista
               mapa: se marca la tarjeta y no se toca ninguna fuente */
            const source = this.Map?.getSource(sourceLayer);
            const features = this.Features[sourceLayer] ?? [];

            features.forEach( item => {
                item.properties.selected = (item.properties.id == properties.id);
            });

            source?.setData({ type: 'FeatureCollection', features });
            this.goToLocation(...feature.geometry.coordinates.slice());
            /*new mapboxgl.Popup({ offset: 20, closeButton: false , closeOnClick: true})
                .setLngLat(feature.geometry.coordinates.slice())
                .setHTML(`
                    <div class="flex flex-col py-1 px-4 gap-2">
                        <p class="text-xs !text-sc-color-muted-foreground">
                            ${properties.tipo}
                        </p>
                        <p class="m-0 text-body-md p-sc-spacing-button-padding-none">
                            <strong>${properties.name}</strong>
                        </p>
                    </div>
                `)
                .addTo(this.Map);
            */
            if(this.CustomPopupElement){
                this.CustomPopupElement.classList.remove("hidden");

                /* Se monta por nodos y no con innerHTML: el nombre y el tipo vienen del PIM y
                   con innerHTML cualquier etiqueta que traigan se ejecuta */
                this.CustomPopupElement.replaceChildren(
                    this.buildElement('p', 'text-xs !text-sc-color-muted-foreground', properties.tipo),
                    this.buildElement('p', 'm-0 text-body-lg p-sc-spacing-button-padding-none', properties.name, 'strong')
                );
            }

            this.activeResultStore(properties.id);
        },

        /**
         * Crea un <p> con su texto, opcionalmente envuelto en otra etiqueta.
         */
        buildElement: function(tag, classes, text, wrapper = null){
            const element = document.createElement(tag);
            element.className = classes;

            if(wrapper){
                const inner = document.createElement(wrapper);
                inner.textContent = text ?? '';
                element.appendChild(inner);

                return element;
            }

            element.textContent = text ?? '';

            return element;
        },

        getFeatureGeoJson: function(featureId, sourceLayer = "distributors"){
            // Copia local en vez de source._data, que es API privada de Mapbox
            const features = this.Features[sourceLayer] ?? [];

            return features.find( feature => feature.properties.id == featureId);
        },

        getContinent: function() {
            return this.SelectContinent ? this.SelectContinent.value : '';
        },

        searchInMap: function() {
            const query = this.InputSearchElement.value.trim();
            /* Solo se quitan los caracteres que romperian la URL. El filtro de antes dejaba
               pasar unicamente ASCII, asi que "Málaga" viajaba como "Mlaga" y no encontraba
               nada; con encodeURIComponent el resto es seguro */
            const validQuery = query.replace(/[<>"'`\\]/g, '');

            const continentSelect = this.getContinent();
            const continent = this.Regions.find((region) => region.name === continentSelect)?.bbox.toString();

            // Evitar búsquedas demasiado cortas
            if(validQuery.length < 3)  return;

            /* Las respuestas pueden llegar desordenadas: solo se pinta la de la ultima peticion */
            const requestId = ++this.SearchRequestId;

            /* Geocoding v6. La v5 (/geocoding/v5/mapbox.places) esta deprecada, y de paso la v6
               resuelve el problema de los codigos de region: en `context.region` trae el codigo
               del nivel que toca y en `context.region.alternate` el del otro nivel, asi que para
               Barcelona llegan ES-B (provincia) y ES-CT (comunidad, que es lo que guarda el PIM)
               y se pueden mandar los dos. Con la v5 solo venia uno y casi nunca el bueno. */
            fetch(`https://api.mapbox.com/search/geocode/v6/forward?q=${encodeURIComponent(validQuery)}&access_token=${mapboxgl.accessToken}&limit=5${continent ? `&bbox=${continent}` : ''}`)
            .then(response => response.json()) // Procesar la respuesta a JSON
            .then( data => {
                if(requestId !== this.SearchRequestId) return;
                // Verificar si hay resultados
                if (!data || !data.features || data.features.length === 0) {
                    console.error('No se encontraron resultados para la búsqueda:', query);
                    return;
                }

                // Limpiar las sugerencias anteriores
                this.SuggestionsElement.innerHTML = '';
                this.SuggestionsElement.parentElement.classList.remove('hidden');

                // Iterar sobre los resultados y crear elementos de sugerencia
                data.features.forEach(feature => {
                    const properties = feature.properties ?? {};
                    const context    = properties.context ?? {};
                    const type       = properties.feature_type ?? '';

                    // En la v6 las coordenadas vienen en el geometry del feature
                    const [lng, lat] = feature.geometry?.coordinates ?? [];

                    if(!Number.isFinite(lng) || !Number.isFinite(lat)) return;

                    const item = document.createElement('li');
                    item.textContent = properties.full_address ?? properties.place_formatted ?? properties.name ?? '';
                    item.style.cursor = 'pointer';
                    item.dataset.lng = lng;
                    item.dataset.lat = lat;

                    /* Nombres, solo para decidir el zoom */
                    item.dataset.city    = type === 'place' ? (properties.name ?? '') : (context.place?.name ?? '');
                    item.dataset.region  = type === 'region' ? (properties.name ?? '') : (context.region?.name ?? '');
                    item.dataset.country = type === 'country' ? (properties.name ?? '') : (context.country?.name ?? '');

                    /* Y los CODIGOS, que son los que se mandan al filtrar. El PIM guarda ISO
                       3166-1 en `country_code_$i` e ISO 3166-2 en `region_code_$i`.

                       De la region se mandan los dos candidatos separados por coma: Mapbox da el
                       codigo del nivel que ha resuelto y en `alternate` el del otro nivel (para
                       Barcelona, ES-B la provincia y ES-CT la comunidad), y no hay forma de saber
                       de antemano cual usa el PIM en cada pais */
                    /* El contexto primero y el nivel raiz como red: en una sugerencia de tipo
                       "region" el codigo viene en `context.region` y no en las properties del
                       feature, y al reves en otras */
                    const regionSource = context.region ?? properties;
                    const regionCodes = [
                        regionSource?.region_code_full,
                        regionSource?.alternate?.region_code_full
                    ].filter(Boolean).map(code => code.toUpperCase());

                    item.dataset.countryCode = ((context.country?.country_code ?? properties.country_code) ?? '').toUpperCase();
                    item.dataset.regionCode  = [...new Set(regionCodes)].join(',');

                    // Añadir el elemento al contenedor de sugerencias
                    this.SuggestionsElement.appendChild(item);
                });
            })

            // Manejar errores de la búsqueda
            .catch(error => {
                console.error('Error buscando ubicación:', error);
            });
        },

        loadDistributors: function(continent = '', countryCode = '', regionCode = '', city = '') {

            fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    city: city,
                    /* Codigos ISO, no nombres: ver el comentario de searchInMap() */
                    region_code: regionCode,
                    continent: continent,
                    country_code: countryCode,
                    action: 'get_stores',
                })
            })
            .then(response => response.json())
            .then(response => {
                if( !response || !response.success){
                    /* Antes se salia en silencio: el contador se quedaba con los puntos
                       suspensivos y la lista con los resultados del continente anterior */
                    this.clearContainerResult();
                    this.Features.distributors = [];
                    this.Map?.getSource('distributors')?.setData({ type: 'FeatureCollection', features: [] });

                    this.filterResults();

                    console.warn('No se han podido cargar los distribuidores', response?.data?.message ?? '');
                    return;
                }

                this.clearContainerResult();

                /* El endpoint ya devuelve una tienda por direccion, con sus campos resueltos:
                   antes llegaba el distribuidor entero repetido y aqui se volvia a recorrer del
                   1 al 5 usando `total_urls.length` como tope, que al ser un string ("4") valia
                   1 y dejaba fuera todas las direcciones menos la primera */
                const stores = Array.isArray(response.data) ? response.data : [];

                stores.forEach(store => this.addResulStore(store));

                /* Reaplica el filtro de la lista sobre lo que se acaba de pintar y pone el
                   contador: si el usuario tenia algo escrito, no se le deshace al cambiar de
                   continente */
                this.filterResults();

                const features = stores.map(store => ({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [
                            parseFloat(store.lng),
                            parseFloat(store.lat)
                        ]
                    },
                    properties: {
                        id: store.id,
                        name: store.name,
                        tipo: store.tipo,
                        address: store.direccion,
                        city: store.ciudad,
                        country: store.pais,
                        postal: store.cod_postal
                    }
                })).filter(feature => feature.geometry.coordinates.every(Number.isFinite));

                this.Features.distributors = features;
                this.Map?.getSource('distributors')?.setData({ type: 'FeatureCollection', features });
            })
            .catch(error => console.error('Error cargando los distribuidores:', error));
        },

        goToLocation: function(lng, lat, zoom = 13) {
            // En movil no hay mapa que mover, solo lista
            if(!this.Map) return;

            // Actualizar el mapa con la ubicación encontrada
            let options = {
                center: [lng, lat],
                essential: true,
                zoom: zoom,
            }
            this.Map.flyTo(options);
        },

        addResulStore: function(store){
            const templateStore = document.getElementById('wtb-template-stores');
            const container = document.getElementById('wtb-mapbox-results');

            if(!templateStore || !container) return;

            const cloneTemplate = templateStore.cloneNode(true);
            const continent = this.getContinent();

            /* Ciudad, (estado solo en Norteamerica) CP, Pais — montado solo con las partes que
               vienen. La plantilla de antes ("{city}, {stateCode} {postalCode}, {country}") nunca
               quedaba vacia, asi que a una tienda sin ciudad ni pais le salia un ", ," suelto y
               la guarda que debia ocultar la linea no se cumplia jamas */
            const locationParts = [
                store.ciudad,
                [continent == 'north america' ? store.region_code : '', store.cod_postal].filter(Boolean).join(' '),
                store.pais
            ].filter(part => (part ?? '').toString().trim() !== '');
            const locationText = locationParts.join(', ');

            // Atributes html node
            cloneTemplate.removeAttribute('id');
            cloneTemplate.classList.remove('hidden');
            cloneTemplate.dataset.lng = store.lng;
            cloneTemplate.dataset.lat = store.lat;
            cloneTemplate.setAttribute("id", store.id);

            /* textContent y no innerHTML: son datos del PIM */
            const fields = {
                '.store-name': store.name,
                '.store-address': store.direccion,
                '.store-tel': store.telefono,
                '.store-city': locationText
            };

            Object.entries(fields).forEach(([selector, value]) => {
                const node = cloneTemplate.querySelector(selector);
                if(!node) return;

                node.textContent = value ?? '';

                // si no hay valor en los campos de texto ocultamos el campo
                if(!value) node.classList.add('hidden');
            });

            // Add templete to html results
            container.appendChild(cloneTemplate);
        },

        /**
         * Filtra las tarjetas ya pintadas por el texto del buscador de la lista.
         *
         * Ademas es quien pone el contador, para que "Showing N results" cuente siempre lo que hay
         * a la vista y no lo que trajo la ultima peticion.
         */
        filterResults: function(){
            const query = this.normalizeText(this.FilterResultsElement?.value ?? '');
            const cards = this.getResultCards();
            let visible = 0;

            cards.forEach(card => {
                const matches = query === '' || this.normalizeText(card.textContent).includes(query);

                card.classList.toggle('hidden', !matches);

                if(matches) visible++;
            });

            if(this.CountResultsElement) this.CountResultsElement.textContent = visible;

            /* El aviso sale solo cuando quien deja la lista vacia es el filtro: si es que no hay
               tiendas en ese continente, el cero del contador ya lo dice */
            this.EmptyResultsElement?.classList.toggle('hidden', !(visible === 0 && query !== ''));
        },

        /**
         * Tarjetas pintadas en la lista, sin contar la plantilla oculta.
         */
        getResultCards: function(){
            const cards = this.ContainerResultsElement?.querySelectorAll('.wtb-store') ?? [];

            return [...cards].filter(card => card.id !== 'wtb-template-stores');
        },

        /**
         * En minusculas y sin acentos, para que "Malaga" encuentre "Málaga".
         */
        normalizeText: function(text){
            return (text ?? '')
                .toString()
                .toLowerCase()
                .normalize('NFD')
                .replace(/\p{Diacritic}/gu, '')
                .trim();
        },

        activeResultStore: function(elementId){
            /* `is-active` deja crecida la barra de la izquierda (ver store-locator.css). Antes se
               intercambiaban dos clases de color de borde, que era el borde que se ha sustituido
               por la barra animada */
            const stores = document.querySelectorAll('#wtb-mapbox-results .wtb-store');
            stores.forEach(store => store.classList.remove('is-active'));

            /* La tienda puede no estar en la lista pintada (marcador de galeria, o un id que ya
               no esta tras cambiar de continente): antes era un scrollIntoView sobre null */
            const element = document.getElementById(elementId);

            if(!element) return;

            element.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
            });
            element.classList.add('is-active');
        },

        clearContainerResult(){
            const container = document.getElementById('wtb-mapbox-results');

            [...container.children].forEach(child => {
                if (child.id !== 'wtb-template-stores') {
                    container.removeChild(child);
                }
            });
        }
    };

    /* FindYourRep se ha llevado a find-your-rep.js: lo usan los bloques de representantes y de
       tiendas online, que no tienen mapa y no deberian cargar Mapbox por venir en este bundle */

    $(document).ready(() => Stores.init());

})(window.jQuery);
